var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666626 3.00033V7.00032C0.666626 8.4889 0.666626 9.23318 1.15213 9.52448C1.63763 9.81579 2.29436 9.46554 3.6078 8.76503L7.3578 6.76503C8.81369 5.98856 9.54163 5.60033 9.54163 5.00033C9.54163 4.40033 8.81369 4.01209 7.3578 3.23562L3.6078 1.23562C2.29436 0.535115 1.63763 0.184863 1.15213 0.476166C0.666626 0.767468 0.666626 1.51175 0.666626 3.00033Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnNext);
export default __webpack_public_path__ + "static/media/btn-next.86eccaca0dd859242051e27011902f47.svg";
export { ForwardRef as ReactComponent };